import { call, put } from 'redux-saga/effects';
import serviceLocator, { COMMON_SVC } from '@APIs/common/service-locator';
import { setEnvironments } from '@actions/common/actionCreators';

// Utils

import { dateMethods } from '@utils/dates/dateMethods';
import { localStorageHyperDashboardTools } from '@utils/tools/localStorageHyperDashboardTools';
import { formatDate } from '@utils/dates/date.utils';

// Constants

import { configs } from '@constants/configs/configs';
import { MM_SLASH_DD_SLASH_YYYY } from '@utils/dates/dateFormats.utils';
import { FULL_STACK_STATES } from '../../utils/miscellaneous/states';
import { IEX_STATE_CODES } from '@constants/configs/states';

export function* environmentSaga() {
    try {
        const commonService = yield call(serviceLocator, COMMON_SVC);
        const data = yield call([commonService, commonService.getEnvironment]);

        if(data) {
            window.UID = data.user && data.user.userId;
            window.EMAIL = data.user && data.user.userName;

            const {
                serverDate,
                oepStartDate,
                oepEndDate,
                oepEnrollStartDate,
                oepEnrollEndDate,
                exceptionalCircumstancesStartDate,
                exceptionalCircumstancesEndDate,
                timezone,
                globalConfigCoverageStartDate,
                timezoneOffsetMs,
                dstSavingsMs
            } = data.localDates;

            serverDate && localStorage.setItem('serverDate', formatDate(serverDate, MM_SLASH_DD_SLASH_YYYY));
            serverDate && global.localStorage.setItem('serverDate', formatDate(serverDate, MM_SLASH_DD_SLASH_YYYY));

            try {
                const FAV_ICON = data.assets.FAV_ICON;
                document.getElementById('favicon').setAttribute('href', FAV_ICON);
            } catch(e) {
                console.log('It is not able to set favicon');
            }

            const stateCode = configs.ENV.DEVELOPMENT
                ? localStorageHyperDashboardTools.getValueByPropName('stateCode', IEX_STATE_CODES.GA)
                : data.stateCode;

            const isState = Object
                .values(configs.states)
                .reduce(
                    (res, stateName) => ({
                        ...res,
                        [stateName]: stateName === stateCode
                    }),
                    {}
                );
            const isStateFullStack =  FULL_STACK_STATES.includes(data.stateCode) || data.isMNFullStack;
            const localDates = {

                // To support 8888, by default (when serverDate === null in mock):
                serverDate: serverDate ? serverDate : new Date().getTime(),
                oepStartDate,
                oepEndDate,
                oepEnrollStartDate,
                oepEnrollEndDate,
                exceptionalCircumstancesStartDate,
                exceptionalCircumstancesEndDate,
                timezone,
                globalConfigCoverageStartDate,
                serverDateInUTC: serverDate,
            };
            // Convert dates into 'MM-DD-YYYY' format.
            for (let date in localDates) {
                if(date === 'timezone') {
                    localDates.timezone = timezone;
                } else if (date === 'serverDate') {
                    localDates[date] = dateMethods.formatDateTime(localDates[date]);
                } else if(date === 'serverDateInUTC') {
                    localDates[date] = localDates[date].replace(' ', 'T') + 'Z';
                } else {
                    localDates[date] = dateMethods.formatDate(localDates[date]);
                }
            }
            localDates.timezoneOffsetMs = timezoneOffsetMs;
            localDates.dstSavingsMs = dstSavingsMs;
            yield put(setEnvironments({ ...data, stateCode, isState, localDates, isStateFullStack }));
        }
    } catch(e) {
        yield console.log('%c Environment fetching is failed! ', 'background: #FF0000; color: #bada55',e);
    }
}
